import React from 'react';

import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
} from '@mui/material';

import type { AttendContactLateJson } from '@/types/domain/attendContact/entities/attendContactLateEntity';

import DialogTitle from '@/components/DialogTitle';
import DialogTransition from '@/components/DialogTransition';
import LateInfo from '@/domain/attendContact/component/LateInfo';

/**
 * プロパティ
 */
export type DetailLateInput = {
  /** データ */
  data: AttendContactLateJson | undefined,
  /** 閉じる */
  close: () => void,
}

const DetailLate: React.FC<DetailLateInput> = ({ data, close }) => (
  <Dialog
    open={data !== undefined}
    onClose={() => close()}
    fullScreen
    TransitionComponent={DialogTransition}
  >
    <DialogTitle title="遅刻連絡" />
    <DialogContent>
      {data && <LateInfo data={data} />}
    </DialogContent>
    <DialogActions>
      <Button variant="contained" onClick={() => close()} color="primary">
        閉じる
      </Button>
    </DialogActions>
  </Dialog>
);

export default DetailLate;
